module.exports = __webpack_public_path__ + "img/menu-push.401ffa27.png";